import {
  REPORT_INFO,
  REPORT_INFO_SUCCESS,
  REPORT_INFO_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  reportInfo: [],
};

const reportInfoReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case REPORT_INFO:
      return { ...state, loading: true };
    case REPORT_INFO_SUCCESS:
      return {
        ...state,
        reportInfo: action?.payload,
        loading: false,
      };
    case REPORT_INFO_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default reportInfoReducer;
